export const APP_VERSION = process.env.APP_VERSION || "2025.0.0-local";
export const APP_COMMIT_DATE = process.env.COMMIT_DATE || "2025-01-01T00:00:00.000Z";
export const APP_ENV = process.env.APP_ENV || "local";
export const APP_VERSION_EXTENDED = process.env.APP_VERSION_EXTENDED || "0.0.0+local+abcdefg";
/**
 * Whether the current environment is a PR preview environment.
 * APP_ENV has the format "preview-{PR_NUMBER}" in PR preview builds.
 */
export function isPreviewEnvironment() {
    return APP_ENV.startsWith("preview-");
}
/**
 * Gets the PR number from APP_ENV if in a preview environment.
 * Returns undefined if not in a preview environment.
 *
 * APP_ENV has the format "preview-{PR_NUMBER}" in PR preview builds.
 *
 * NOTE: In the future, version.json should include the PR number as a separate field.
 * See Linear task for tracking this improvement.
 */
export function getPrNumber() {
    const match = APP_ENV.match(/^preview-(\d+)$/);
    return match ? match[1] : undefined;
}
//# sourceMappingURL=index.js.map